// import React from 'react'
// import { Modal, Row, Col, Card } from "react-bootstrap";
// import { Helmet } from "react-helmet";

// export default class Bonus extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {};
//     }

//     componentWillMount() {
//         document.body.scrollTop = 0;
//         document.documentElement.scrollTop = 0;
//     }

//     render() {
//         return (
//             <>
//                 <Helmet>
//                     <title>Bonus</title>
//                     <meta name="keywords" content="Crypto Slot Games, Online Slot Games, Bitcoin Slot Games, Blockchain Slot Games, Best Crypto Slot Games, PlayCrash.com Slot Games" />
//                     <meta name="description" content="Play Online Slot Games - Play with BTC, ETH LTC, USDT, BCH, TRX and many more !" />
//                     <meta name="og:title" content="Play Online Slot Games - Play with BTC, ETH LTC, USDT, BCH, TRX and many more !" />
//                     <meta name="og:description" content="Play Online Slot Games - Play with BTC, ETH LTC, USDT, BCH, TRX and many more !" />
//                     <link rel="canonical" href="/bonus" />
//                 </Helmet>
//                 <div>
//                     <Card className="levbg bg-dark text-white">
//                         <Card.Body>
//                             <h1 className="text-center">Level Up Rewards</h1>
//                             <Card.Text className="font-17 font-weight-bold text-center">
//                                 Collect all medals and get rewarded !
//                             </Card.Text>
//                             <div className={"medals-view mt-5"}>
//                                 <Row>
//                                     <Col sm="12" md="6">
//                                         <div className="media mb-2">
//                                             <img src="/assets/images/badges/badge-2.svg" height="60" className="mr-3" />
//                                             <div className="media-body align-self-center">
//                                                 <div className="mb-2">
//                                                     <span className="badge badge-purple px-3">1</span>
//                                                 </div>
//                                                 Required Minimum 100 USD Deposit
//                                             </div>
//                                         </div>
//                                     </Col>
//                                     <Col sm="12" md="6">
//                                         <div className="media mb-2">
//                                             <img src="/assets/images/badges/badge-3.svg" height="60" className="mr-3" />
//                                             <div className="media-body align-self-center">
//                                                 <div className="mb-2">
//                                                     <span className="badge badge-purple px-3">2</span>
//                                                 </div>
//                                                 Required Minimum 500 USD Deposit
//                                             </div>
//                                         </div>
//                                     </Col>
//                                     <Col sm="12" md="6">
//                                         <div className="media mb-2">
//                                             <img src="/assets/images/badges/badge-7.svg" height="45" className="mr-3" />
//                                             <div className="media-body align-self-center">
//                                                 <div className="mb-2">
//                                                     <span className="badge badge-purple px-3">3</span>
//                                                 </div>
//                                                 Required Minimum 2000 USD Deposit
//                                             </div>
//                                         </div>
//                                     </Col>
//                                     <Col sm="12" md="6">
//                                         <div className="media mb-2">
//                                             <img src="/assets/images/badges/badge-6.svg" height="60" className="mr-3" />
//                                             <div className="media-body align-self-center">
//                                                 <div className="mb-2">
//                                                     <span className="badge badge-purple px-3">4</span>
//                                                 </div>
//                                                 Required 10 Times Rain
//                                             </div>
//                                         </div>
//                                     </Col>
//                                     <Col sm="12" md="12">
//                                         <div className="media my-2">
//                                             <img src="/assets/images/badges/badge-8.svg" height="60" className="mr-3" />
//                                             <div className="media-body align-self-center">
//                                                 <div className="mb-2">
//                                                     <span className="badge badge-purple px-3">5</span>
//                                                 </div>
//                                                 Required 2500 USD Profit
//                                             </div>
//                                         </div>
//                                     </Col>
//                                 </Row>
//                             </div>
//                         </Card.Body>
//                     </Card>
//                 </div>
//             </>
//         );
//     }
// }

import React from "react";
import "./bonus.css";

const index = () => {
  return (
    <div>
      {/* banner section */}
      <section className="Bannersection">
        <div className="banner-bonus game-fonts">
          <div className="banner-bonus-content game-fonts">
            <div className="game-fonts banner-bonus-h">
              Unlock <span className="game-fonts endless">Endless</span>{" "}
              benefits
            </div>
            <div className="game-fonts banner-bonus-p">
              Join now and embark on an exhilarating journey <br></br> of luck
              and reward
            </div>
            <a href="#">
              {" "}
              <button className="bonus-button">Sign Up</button>
            </a>
          </div>
          <div className="banner-bonus-img">
            <img src="/assets/bcimages/bonus/bonus banner.webp" />
          </div>
        </div>
      </section>

      {/* spin section */}
      <section className="Spinsection">
        <div className="bonus-number-container">
          <div className="num-cont">
            <div className="bonus-no">
              <span>01</span>Sign up & make a deposit
            </div>
          </div>
          <div className="num-cont">
            <div className="bonus-no">
              <span>02</span>Sign up & make a deposit
            </div>
          </div>
          <div className="num-cont">
            <div className="bonus-no">
              <span>03</span>Sign up & make a deposit
            </div>
          </div>
        </div>
        <div className="bonus-spin-container">
          <div className="b-spin">
            <div className="b-spin-content">
              <div className="spin-cont-p game-fonts">Up to 100% bonus +</div>
              <div className="spin-cont-p2">400 Free Spin in Casino</div>
              <button className="btn-b-detail">Bonus Details</button>
              <a href="#">
                {" "}
                <button className="bonus-button-deposit" id="deposit-btn">
                  Deposit Now
                </button>
              </a>
            </div>
            <div className="b-spin-img">
              <img src="assets/bcimages/bonus/banner-casino-87e5d3e8.webp" />
            </div>
          </div>
          <div className="b-spin bonus-spin">
            <div className="b-spin-content">
              <div className="spin-cont-p game-fonts">Up to 100% bonus +</div>
              <div className="spin-cont-p2">400 Free Spin in Casino</div>
              <button className="btn-b-detail">Bonus Details</button>
              <a href="#">
                {" "}
                <button className="bonus-button-deposit" id="deposit-btn">
                  Deposit Now
                </button>
              </a>
            </div>
            <div className="b-spin-img">
              <img src="assets/bcimages/bonus/banner-sport.webp" />
            </div>
          </div>
        </div>
      </section>

      {/* vip section */}
      <section className="Vipsection">
        <div className="vip">
          <div className="vip-container">
            <div className="vip-content">
              <div className="vip-h1">
                Reach new heights with our
                <br /> Level Up bonus
              </div>
              <div className="vip-p">
                Level up to earn substantial <span>cash</span> rewards and{" "}
                <span>free lucky spins!</span> <br /> The higher your level, the
                bigger the rewards.
              </div>
              <div className="vip-btn">Level up bonus detail</div>
              <div>
                <a href="#">
                  {" "}
                  <button className="bonus-button" id="deposit-btn">
                    Unlock Level-up Bonus
                  </button>
                </a>
              </div>
            </div>
            <div className="vip-img">
              <img src="assets/bcimages/bonus/vip img1.webp" />
            </div>
          </div>
          <div className="vip-container">
            <div className="vip-img">
              <img src="assets/bcimages/bonus/vip img2.webp" />
            </div>
            <div className="vip-content" id="vip-content">
              <div className="vip-h1">
                Maximize the Potential of
                <br /> BCD/fiat Rakeback
              </div>
              <div className="vip-p">
                Unlock your potential with our Rakeback program! Earn
                <br /> bonuses with every wager and watch your balance grow
                <br /> continuously.
              </div>
              <div className="vip-btn">Rackback Details</div>
              <div>
                <a href="#">
                  {" "}
                  <button className="bonus-button" id="deposit-btn">
                    Unlock Rackback
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* lot of free perks section */}

      <section className="LotofperksSsection">
        <div className="lot">
          <div className="lot-container">
            <div className="lot-h1">
              Get A Lot Of <span>Free</span> Perks
            </div>
            <div className="lot-box">
              <div className="everyday-box">
                <div className="day-h">Every Day & Week</div>
                <div className="lot-every-img">
                  <div className="lot-e-i-h">Quest Hub daily</div>
                  <div className="lot-e-i-i">
                    <img src="assets/bcimages/bonus/everyday1.webp" />
                  </div>
                </div>
                <div className="lot-every-content">
                  Conquer daily and weekly quests while amassing and snowballing
                  your earnings!
                </div>
              </div>
              <div className="everyday-box">
                <div className="day-h">Every Day</div>
                <div className="lot-every-img">
                  <div className="lot-e-i-h">Free Lucky Spins</div>
                  <div className="lot-e-i-i">
                    <img src="assets/bcimages/bonus/everyday2.webp" />
                  </div>
                </div>
                <div className="lot-every-content">
                  Spin and win your daily opportunity to bag up to 5 BTC - the
                  ultimate thrill in every roll!
                </div>
              </div>
              <div className="everyday-box">
                <div className="day-h">Every Day</div>
                <div className="lot-every-img">
                  <div className="lot-e-i-h">Free roll competitions</div>
                  <div className="lot-e-i-i">
                    <img src="assets/bcimages/bonus/everyday3.webp" />
                  </div>
                </div>
                <div className="lot-every-content">
                  The earlier you roll the same score, the higher you rank - let
                  the games begin!
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Recharge section */}
      <section className="RechargeSection">
        <div className="recharge">
          <div className="recharge-container">
            <div className="recharge-img">
              <img src="assets/bcimages/bonus/recharge img.webp" />
            </div>
            <div className="recharge-content">
              <div className="recharge-h1">
                Introducing Our Very Own Recharge Cashback
              </div>
              <div className="recharge-p">
                Immerse yourself in the exhilarating world of Recharge, where
                the power is in your hands. Customize your reward claiming by
              </div>
              <div className="recharge-btn">Recharge Details</div>
              <div>
                <a href="#">
                  {" "}
                  <button className="bonus-button" id="deposit-btn">
                    Join MigBet888 Now
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="recharge-container2">
            <div className="recharge-gift">
              <div className="gift-img">
                <img src="assets/bcimages/bonus/recharge-1.webp" />
              </div>
              <div className="gift-content">
                <div className="gift-h">Recharge Activation</div>
                <div className="gift-p">
                  Recharge activate as you strive to reach VIP level 22 and
                  beyond.
                </div>
              </div>
            </div>
            <div className="recharge-gift">
              <div className="gift-img">
                <img src="assets/bcimages/bonus/recharge-2.webp" />
              </div>
              <div className="gift-content">
                <div className="gift-h">Recharge Activation</div>
                <div className="gift-p">
                  Recharge activate as you strive to reach VIP level 22 and
                  beyond.
                </div>
              </div>
            </div>
            <div className="recharge-gift">
              <div className="gift-img">
                <img src="assets/bcimages/bonus/recharge-3.webp" />
              </div>
              <div className="gift-content">
                <div className="gift-h">Recharge Activation</div>
                <div className="gift-p">
                  Recharge activate as you strive to reach VIP level 22 and
                  beyond.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lottery section */}
      <section className="LotterySetion">
        <div className="lottery">
          <div className="lottery-container1">
            <div className="lottery-c-h1">
              Get a lot of <span>free</span> perks
            </div>
          </div>
          <div className="lottery-container2">
            <div className="lottery-box">
              <div className="lottery-b-img">
                <img src="assets/bcimages/bonus/lottery-box-1.webp" />
              </div>
              <div className="lottery-b-content">
                <div className="lottery-content-h">Catch coco for Rewards</div>
                <div className="lottery-content-p">
                  Catch the elusive COCO spider every 6 hours on our page and
                  earn exclusive BCD rewards based on your VIP level
                </div>
              </div>
            </div>
            <div className="lottery-box">
              <div className="lottery-b-img">
                <img src="assets/bcimages/bonus/lottery-box-2.webp" />
              </div>
              <div className="lottery-b-content">
                <div className="lottery-content-h">Catch coco for Rewards</div>
                <div className="lottery-content-p">
                  Catch the elusive COCO spider every 6 hours on our page and
                  earn exclusive BCD rewards based on your VIP level
                </div>
              </div>
            </div>
            <div className="lottery-box">
              <div className="lottery-b-img">
                <img src="assets/bcimages/bonus/lottery-box-3.webp" />
              </div>
              <div className="lottery-b-content">
                <div className="lottery-content-h">Catch coco for Rewards</div>
                <div className="lottery-content-p">
                  Catch the elusive COCO spider every 6 hours on our page and
                  earn exclusive BCD rewards based on your VIP level
                </div>
              </div>
            </div>
          </div>
          <div className="lottery-container3">
            <div className="lottery-signup-h">
              We are proud to provide you with the most luxurious gaming
              experience
            </div>
            <div className="lottery-signup-btn">
              <a href="#">
                {" "}
                <button className="bonus-button" id="deposit-btn">
                  Sign Up
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default index;
